import { render, staticRenderFns } from "./NoticeSvg.vue?vue&type=template&id=eeff7748&"
var script = {}
import style0 from "./NoticeSvg.vue?vue&type=style&index=0&id=eeff7748&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports